import LASGLogo from 'assets/images/lasg.jpeg';

const LASGHeader = () => {
    return (
        <div className="flex__between checkout__header">
            <img src={LASGLogo} alt="LASG" className="logo img-fluid" />
            <div className="text-white text-end">
                <span className="m-0 fw-bold fs-4">LASG Payment</span>
            </div>
        </div>
    );
};

export default LASGHeader;
